const config = {

  PRELUDES_DATA: {
    born: {index: 1, route: 'Born'},
    smog: {index: 2, route: 'Smog'},
    meteo: {index: 3, route: 'Meteo'},
    heat: {index: 4, route: 'Heat'},
    death: {index: 5, route: 'Death'},
  },

  LOCALES: {
    EN: 'en',
    FR: 'fr'
  },

  SETTINGS: {
    Smog: {
      reach: 150,
    },
    Meteo: {
      totalCollision: 300,
    },
  },

  SOUNDS: {
    "fond": {
      loop: true,
      volume: 0.3,
    },
    "bornS": {
      loop: false,
      volume: 0.3,
      onend: true,
    },
    "childhoodS": {
      loop: false,
      volume: 0.3,
      onend: true,
    },
    "mountroyalS": {
      loop: false,
      volume: 0.3,
      onend: true,
    },
    "stadium-snowS": {
      loop: false,
      volume: 0.3,
      onend: true,
    },
    "deathS": {
      loop: false,
      volume: 0.3,
      onend: true,
    },
    "smog-trame": {
      loop: true,
      volume: 2.0,
    },
    "smog-frotte1": {
      loop: false,
      volume: 1.0,
    },
    "smog-frotte2": {
      loop: false,
      volume: 1.0,
    },
    "meteo-trame-before": {
      loop: false,
      volume: 0.6,
      onend: true,
    },
    "meteo-trame-after": {
      loop: true,
      volume: 0.6,
    },
    "heat-trame": {
      loop: false,
      volume: 2.0,
      onend: true
    },
    "tic": {
      loop: false,
      volume: 2.1,
    },
    "heat-fonte1": {
      loop: false,
      volume: 1.3,
    },
    "heat-fonte2": {
      loop: false,
      volume: 1.3,
    },
    "heat-refonte1": {
      loop: false,
      volume: 3.0,
    },
    "heat-refonte2": {
      loop: false,
      volume: 3.0,
    },
    "crack1": {
      loop: false,
      volume: 0.6,
    },
    "crack2": {
      loop: false,
      volume: 0.6,
    },
    "colmate1": {
      loop: false,
      volume: 5.0,
    },
    "colmate2": {
      loop: false,
      volume: 5.0,
    },
  },

  getManifest(id, skipMode = false, isTablet = false) {
    id = skipMode ? "Skip" : id;
    
    const prefix = isTablet ? '-ipad': '';
    let manifest = [];
    
    switch(id) {
      case 'Landing':
        manifest = [
          //sounds
          { id: 'tic', src: '/assets/sounds/tic.webm' },
          { id: 'bornS', src: '/assets/sounds/born.webm' },
          { id: 'fond', src: '/assets/sounds/fond.webm' },

          //SVG
          { id: 'logo1', src: '/assets/intro_logo_pousses.svg' },
          { id: 'logo2', src: '/assets/intro_logo_onf.svg' },
          { id: 'logo3', src: '/assets/intro_logo_uqam.svg' },
          { id: 'logoFR', src: '/assets/logos/titre-fr.svg' },
          { id: 'logoEN', src: '/assets/logos/titre-en.svg' },
          
          //locales
          { id: 'localesFR', src: '/assets/i18n/fr.json' },
          { id: 'localesEN', src: '/assets/i18n/en.json' },
          
          //video (gif)
          { id: 'born', src: '/assets/tableaux/born/born.gif' },
        ];
        break;

        case 'Intro':
          manifest = [
            //video
            { id: 'childhood', src: '/assets/transitions/childhood.gif' },
            { id: 'childhoodS', src: '/assets/transitions/childhood.webm' },
          ]
          break;
          
        case 'BeforeEnter':
          manifest = [
            //son
            { id: 'mountroyal', src: '/assets/transitions/mountroyal.gif' },
            { id: 'mountroyalS', src: '/assets/transitions/mountroyal.webm' },
        ];
        break;

        case 'Born':
          manifest = [
            { id: 'pollutionTB2', data: 'pixi', src: '/assets/tableaux/smog/pollution.png' },
            { id: 'backgroundTB2', data: 'pixi', src: `/assets/tableaux/smog/background${prefix}.png` },
            { id: 'arbreTB2', data: 'pixi', src:`/assets/tableaux/smog/arbre${prefix}.jpg` },
            
            //sound
            { id: 'smog-trame', src: '/assets/sounds/smog-trame.webm' },
            { id: 'smog-frotte1', src: '/assets/sounds/smog-frotte1.webm' },
            { id: 'smog-frotte2', src: '/assets/sounds/smog-frotte2.webm' },
           
            //spritesheet
            { id: 'spsheet-auto1', data:"/assets/tableaux/smog/auto1.png", src: '/assets/tableaux/smog/auto1.json'},
            { id: 'spsheet-auto2', data: "/assets/tableaux/smog/auto2.png", src: '/assets/tableaux/smog/auto2.json'},
            { id: 'spsheet-auto3', data: "/assets/tableaux/smog/auto3.png", src: '/assets/tableaux/smog/auto3.json'},

            //video
            { id: 'stadium-snow', src: '/assets/transitions/stadium-snow.gif' },
            { id: 'stadium-snowS', src: '/assets/transitions/stadium-snow.webm' },
          ];
          break;

          case 'Smog':
            manifest = [
              { id: 'meteo-trame-before', src: '/assets/sounds/meteo-terasse.webm' },
              { id: 'meteo-trame-after', src: '/assets/sounds/meteo-pluie.webm' },
              { id: 'crack1', src: '/assets/sounds/crack1.webm' },
              { id: 'crack2', src: '/assets/sounds/crack2.webm' },
              { id: 'colmate1', src: '/assets/sounds/colmate1.webm' },
              { id: 'colmate2', src: '/assets/sounds/colmate2.webm' },

              { id: 'meteo-bg-step1', data: 'pixi', src: `/assets/tableaux/meteo/background${prefix}.png` },
              { id: 'meteo-bg-step2', data: 'pixi', src: `/assets/tableaux/meteo/background_after${prefix}.png` },
              { id: 'meteo-verre1', data: 'pixi', src: '/assets/tableaux/meteo/verre1.png' },
              { id: 'meteo-verre2',  data:'pixi', src: '/assets/tableaux/meteo/verre2.png' },
             

              //spritesheets
              { id: 'spsheet-rain', src: '/assets/tableaux/meteo/pluie.json' },
              { id: 'spsheet-crack1', src: '/assets/tableaux/meteo/crack1.json' },
              { id: 'spsheet-crack2', src: '/assets/tableaux/meteo/crack2.json' },
              { id: 'spsheet-crack3', src: '/assets/tableaux/meteo/crack3.json' },
          ];
          break;

        case 'Meteo':
          manifest = [
            { id: 'heat-bg-before', data: 'pixi', src: `assets/tableaux/heat/background_before${prefix}.png` },
            { id: 'heat-bg-after', data: 'pixi', src: `assets/tableaux/heat/background_after${prefix}.png` },
            { id: 'melt1TB4', data: 'pixi', src: 'assets/tableaux/heat/melt1.png' },
            { id: 'melt2TB4', data: 'pixi', src: 'assets/tableaux/heat/melt2.png' },
            { id: 'melt3TB4', data: 'pixi', src: 'assets/tableaux/heat/melt3.png' },
            
            { id: 'heat-trame', src: '/assets/sounds/heat-trame.webm' },
            { id: 'fonte1', src: 'assets/sounds/heat-fonte1.webm' },
            { id: 'fonte2', src: 'assets/sounds/heat-fonte2.webm' },
            { id: 'refonte1', src: 'assets/sounds/heat-refonte1.webm' },
            { id: 'refonte2', src: 'assets/sounds/heat-refonte2.webm' },
          ];
          break;
          
          case 'Heat':
            manifest = [
              { id: 'deathS', src: '/assets/sounds/death.webm' },
    
              //video (gif)
              { id: 'death', src: '/assets/tableaux/death/death.gif' },
              
              { id: 'logoAboutFR', src: '/assets/titre/titrePropos-fr.svg' },
              { id: 'logoAboutEN', src: '/assets/titre/titrePropos-en.svg' },
              
          ];
          break;

        case 'Skip':
          var  ids = ['Landing', 'Intro', 'BeforeEnter', 'Born', 'Smog', 'Meteo', 'Heat'];
          manifest = [];
          ids.forEach(id => {
            manifest = manifest.concat(this.getManifest(id, false, isTablet));
          });
        break;
    }

    return manifest;
  },

  ga(eventName, locale) {
    if(!window.google_analytics) return;

    window.google_analytics.gaTrack({
      language: locale,
      name: 'jeune-pousse',
      ua_code: "UA-42015401-43",
      event: eventName
    });
  }
}

export default config;
